var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-pic-container"},[_c('div',{staticClass:"profile-pic",style:(("background-image:url(" + (_vm.item.image ? _vm.imgurl(_vm.item.image.file_url, 'full') : '../../static/img/default_profile.png') + ")"))})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7a0838","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfilePicture.vue
// module id = 940
// module chunks = 1